import { UserProfileData } from 'types/userProfile';

export const GetUserCustomSettings = (): UserProfileData => {
  const DefaultRecordsPerPage = sessionStorage.getItem('DefaultRecordsPerPage');
  const DateTimeFormat = sessionStorage.getItem('DateTimeFormat');
  const DefaultReportFormat = sessionStorage.getItem('DefaultReportFormat');
  const EmailNotification = sessionStorage.getItem('EmailNotification');
  const TaggingToolBar = sessionStorage.getItem('TaggingToolBar');
  const CurrentLandingPage = sessionStorage.getItem('CurrentLandingPage');

  return {
    DefaultRecordsPerPage: DefaultRecordsPerPage ?? null,
    DateTimeFormat: DateTimeFormat ?? null,
    DefaultReportFormat: DefaultReportFormat ?? null,
    EmailNotification: EmailNotification ?? null,
    TaggingToolBar: TaggingToolBar ?? null,
    CurrentLandingPage: CurrentLandingPage ?? null
  };
};

export const ClearUserSettingFromSession = (broadcastChannel?: boolean) => {
  sessionStorage.removeItem('DefaultRecordsPerPage');
  sessionStorage.removeItem('DateTimeFormat');
  sessionStorage.removeItem('DefaultReportFormat');
  sessionStorage.removeItem('EmailNotification');
  sessionStorage.removeItem('TaggingToolBar');
  sessionStorage.removeItem('CurrentLandingPage');

  if (broadcastChannel) {
    const channel = new BroadcastChannel('user-settings');
    channel.postMessage({ type: 'remove' });
  }
};
